import * as React from "react"

import { NotAllowedBlock } from "@components";


export default function topSellersColumn() {
	return {
		name: 'topSellers', label: 'Top 3p Seller',
		options: {
            setCellProps: () => ({ sx: { textAlign: "center" } }),
			customBodyRowRender: (value) => {
				return !!value ? value : <NotAllowedBlock />
			}
        }
	} 
}
